/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:22:33
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare उघडा",
    name2: "आरक्षण करा",
    name3: "Carlcare सोबत, आपण आपली ऑर्डर कधीही तपासू शकता.",
    name4: "",
    name5: "उजवीकडे स्लाईड करा",
    name6: "पडताळणी पूर्ण",
  },
  order: {
    name1: "डिव्हाइस मॉडेल निवडा",
    name2: "दोष वर्णन:",
    name3: "सेवा स्टोअर निवडण्यासाठी टॅप करा",
    name4: "सेवा स्टोअर:",
    name5: "आरक्षण वेळ:",
    name6: "कृपया आपल्या डिव्हाइस समस्येचे विस्तार मध्ये विवरण द्या!",
    name7: "आगमनाची वेळ निवडण्यासाठी टॅप करा",
    name8: "कृपया आपला योग्य तपशील प्रविष्ट करा जेणेकरून आम्ही आपल्यापर्यंत पोहोचू शकू",
    name9: "उपलब्ध आरक्षण वेळ पुढील प्रमाणे",
    name10: "कृपया आपला फोन क्रमांक प्रविष्ट करा",
    name11: "किंमत",
    name12: "वैयक्तिक माहिती:",
    name13: "कृपया आपले नाव प्रविष्ट करा",
    name14: "सबमिट करा",
    name15: "रद्द करा",
    name16: "ठीक आहे",
  },
  shops: {
    name1: "आपल्या ब्रँड निवडीवर आधारित, पुढील स्टोअर आपल्याला सेवा देऊ शकतात!",
    name2: "अधिक रीटेल स्टोअर मध्ये लवकरच येत आहे! आमच्यासोबत रहा!",
  },
  price: {
    name1: "ब्रँड",
    name2: "मॉडेल",
    name3: "आयटम",
    name4: "किंमत",
    name5: "मैत्रीपूर्ण स्मरणपत्र:",
    name6: "या किंमती फक्त संदर्भासाठी आहेत आणि वास्तविक किंमत आपल्या डिव्हाइसच्या शर्तीच्या अधीन आहे.",
    name7: "येथे कोणतेही विशेष चिन्ह नसल्यास, किंमतीचे एकक म्हणजे स्थानिक चलनाचे एकक होय.",
    name8: "क्षमस्व! वर्तमान क्षेत्रासाठी कुठलीही किमतीची माहिती उपलब्ध नाही.",
    name11:"मजुरी",
    name12:"एकूण किंमत",
    name13: "5. जर मजुरी \"/\" असेल तर त्याचा अर्थ असा की मजुरीविषयी स्टोअरशी सल्ला मसलत करणे आवश्यक आहे.",
    item_main_board: "मेनबोर्ड",
    item_screen_frame: "स्क्रीन (फ्रेम)",
    item_screen_screen_frame: "दुय्यम स्क्रीन (फ्रेम)",
    item_touch_screen: "टच स्क्रीन",
    item_camera: "\"कॅमेरा\"",
    item_fixed_focus_camera: "फिक्स्ड फोकस कॅमेरा",
    item_auto_focus_camera: "ऑटो फोकस कॅमेरा",
    item_screen: "स्क्रीन",
    item_secondary_screen: "दुय्यम स्क्रीन",
    item_fingerprint_module: "फिंगरप्रिंट मोड्यूल",
    item_speaker: "स्पीकर",
    item_receiver: "प्राप्तकर्ता",
    item_small_board: "लहान बोर्ड",
    item_battery_cover: "बॅटरी कव्हर",
    item_battery: "बॅटरी",
    item_charger: "चार्जर",
    item_usb_cable: "USB केबल",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "डेटा नाही",
    name2: "सेवा प्रदाता:",
    name3: "सेवा ब्रँड:",
    name4: "टेलिफोन:",
    name5: "ऑर्डरचे प्रमाण:",
    name6: "सेवा रेटिंग",
    name7: "सेवा वातावरण:",
    name8: "सेवा प्रवृत्ती:",
    name9: "सेवा कार्यक्षमता:",
    name10: "सेवा दर्जा:",
    name11: "ग्राहक मूल्यांकन",
    name12:"ते",
    name13:"बंद केले",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare उघडा",
    name1: "कृपया आरक्षण माहितीचा स्क्रीनशॉट घ्या आणि प्राधान्यता सेवा अॅक्सेस करण्यासाठी तो पावती म्हणून जतन करा.",
    name2: "यशस्वीरीत्या प्रविष्ट केले",
    name3: "1. डेटा साफ करा",
    name4: "कृपया महत्त्वाचा खाजगी डेटा आपल्या फोनवर आधीच बॅक अप करा",
    name5: "2. पॉवर-चालू संकेतशब्द अक्षम करा",
    name6: "सेवा स्टोअर मध्ये जाण्यापूर्वी, कृपया:",
    name7: "सेवा स्टोअर:",
    name8: "आरक्षण वेळ:",
    name9: "दोष वर्णन:",
    name10: "डिव्हाइस मॉडेल:",
    name11: "ऑर्डर नंबर:",
    name12: "ऑर्डर माहिती",
  },
  title: {
    
    name1: "पुढील देशांना समर्थित करते:",
    name2: "मॉडेल निवडा",
    name3: "आरक्षण",
    name4: "सेवा स्टोअर तपशील",
    name5: "सेवा स्टोअर निवडा",
  },
  error: {
    
    name1: "कोणताही डेटा नाही. कृपया आपली दुरूस्ती माहिती तपासा",
    name2: "अधिक मदतीची आवश्यकता आहे का? कृपया आमच्याशी संपर्क साधा.",
    name3: "क्षमस्व, वर्तमान क्षेत्रात कुठलेही Carlcare केंद्र नाही.",
    name4: "कृपया पहिले सेवा केंद्र निवडा",
    name5: "अयशस्वी झाले",
    name6: "कृपया पहिले डिव्हाइस मॉडेल निवडा",
    name7: "तपशील",
    name8: "कृपया आपल्या गरजांचे तपशीलवार विवरण द्या",
    name9: "",
  },
  add1:{
    "name0": "mr-rIN",
    "name1": "आपल्या ऑर्डरची पुष्टी केली गेली आहे. आम्ही आपल्या आगमनासाठी उत्सुक आहोत.",
    "name2": "शहर निवडा",
    "name3": "कृपया %1$s अंकांचा फोन नंबर इनपुट करा.",
    "name4": "आठवड्यातील दिवसाचे तास",
    "name5": "\"सोमवार\"",
    "name6": "मंगळवार",
    "name7": "बुधवार",
    "name8": "गुरूवार",
    "name9": "शुक्रवार",
    "name10": "\"शनिवार\"",
    "name11": "\"रविवार\"",
    "name12": "देश प्रविष्ट करा आणि शोधा"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "इतर",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"पुनर्निर्देशन करण्यासाठी टॅप करा",
    name3:"ऑर्डरला रेटिंग देण्यासाठी Carlcare ॲप उघडा",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"सेवा निवडा",
    name7:"मोफत स्वच्छता",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "चुकीची माहिती",
    "cancelReason1": "वेळेवर पोहोचू शकत नाही",
    "cancelReason2": "डुप्लिकेट ऑर्डर/माझी ऑर्डर नाही",
    "cancelReason3": "अपयश दिसले नाही",
    "cancelReason4": "फक्त चाचणी/चौकशी/इव्हेंट करिता…",
    "cancelReason5": "अधिक किंमत",
    "cancelReason6": "साहित्याची कमतरता",
    "cancelReason7": "विविध किमती नाहीत",
    "cancelReason8": "स्टोअर खूप दूर आहे",
    "cancelReason9": "स्टोअर बंद आहे",
    "cancelReason10": "खराब सेवा वृत्ती",
    "cancelReason11": "बदली/इतर ब्रँड करिता दुरूस्ती",
    "cancelReason12": "स्टोअर शोधू शकत नाही",
    "cancelReason13": "अन्य",
    "cancelOrder": "ऑर्डर रद्द करा",
    "reason_dialog_title": "कृपया रद्द करण्याचे आम्हाला कारण सांगा",
    "Cancel": "रद्द करा",
    "OK": "ठीक आहे",
    "name1": "सत्यापन कोड प्रविष्\u200dट करा",
    "name2": "अवैध सत्यापन कोड",
    "repair_reservation_detail_canceled": "ऑर्डर रद्द केली गेली आहे!",
    "purchase_cancel_dialog_content": "तुम्हाला ऑर्डर रद्द करण्याची पुष्टी करायची आहे का?",
    "yes": "होय",
    "no": "नाही"
}
};
